/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('UserService', UserService);

  UserService.$inject = ['$resource'];

  function UserService ($resource) {
    return $resource(apiUrl + '/users/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      setStatus: { url: apiUrl + '/change-status', method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      updateMyAccount: { url: apiUrl + '/my-account/:id', method: 'POST', params: { id: '@id', _method: 'PATCH' }, isArray: false },
      find: { url: apiUrl + '/users/:id', method: 'GET', params: {}, isArray: false },
      saveUserSectors: { url: apiUrl + '/users/:id/sectors', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true },
      changePassword: { url: apiUrl + '/change-password', method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      filterUser: { url: apiUrl + '/users', method: 'GET', isArray: false },
      findAll: { url: apiUrl + '/users-all/:id', method: 'GET', isArray: true },
      searchUserByEmail: { url: apiUrl + '/search-user-by-email', method: 'POST', isArray: false },
      user_data: { url: apiUrl + '/user_data', method: 'GET', params: {}, isArray: false },
      company_metadata: { url: apiUrl + '/company-metadata', method: 'GET', params: {}, isArray: false },
      getSockeToken: { url: apiUrl + '/get-socket-token', method: 'GET', params: {}, isArray: false },
      searchUserByRole: { url: apiUrl + '/search-user-by-role', method: 'GET', isArray: true },
      getUsersByRoles: { url: apiUrl + '/get-users-by-roles', method: 'GET', isArray: true },
      getUsersToTurnThemIntoLord: { url: apiUrl + '/get-users-to-turn-them-into-lord', method: 'GET', isArray: true },
      updateUserRoleByUserId: { url: apiUrl + '/turn-user-to-lord', method: 'PATCH', isArray: false }

    })
  }
// eslint-disable-next-line semi
})();
